export const getDegreeClassesByYear = async (acadPlanClasses) => {
  const buildClassListsByYear = (year, classList) => {
    const filteredByYear = Object.values(classList).filter((classObj) => {
      return classObj.year === year;
    });

    return filteredByYear;
  };

  const handleNewDegree = async () => {
    const year1 = await buildClassListsByYear(1, acadPlanClasses);
    const year2 = await buildClassListsByYear(2, acadPlanClasses);
    const year3 = await buildClassListsByYear(3, acadPlanClasses);
    const year4 = await buildClassListsByYear(4, acadPlanClasses);

    return { year1, year2, year3, year4 };
  };

  return handleNewDegree();
};
